/* eslint-disable react/prop-types */
import { useContext, useMemo } from "react";
import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Button,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import { Context } from "../../hooks/useAuthContext";
import "./styles.css";
import { Link } from "react-router-dom";

function SideMenuAdmin({ isOpen, onClose }) {
  const { logout, userData } = useContext(Context);
  const tipoConta = userData?.tipoConta;

  const podeVerFinanceiro = useMemo(() =>
    ['administrador', 'financeiro'].includes(tipoConta),
    [tipoConta]
  );

  const podeVerLogs = useMemo(() =>
    ['administrador', 'coordenacao'].includes(tipoConta),
    [tipoConta]
  );

  function handleLogout() {
    logout();
  }

  return (
    <Offcanvas isOpen={isOpen} toggle={onClose} direction="end">
      <OffcanvasHeader toggle={onClose}>Menu</OffcanvasHeader>
      <div className="dadosSideBar">
        <span className="nomeUser">Olá, {userData?.nome.split(" ", 1)}</span>
        <span className="emailUser">{userData?.email}</span>
      </div>
      <OffcanvasBody>
        <ListGroup flush>

          {podeVerFinanceiro && (
            <>
              <ListGroupItem tag={Link} to="/admin/descontos" action>
                Descontos
              </ListGroupItem>
              <ListGroupItem tag={Link} to="/admin/notas-fiscais" action>
                Notas Fiscais
              </ListGroupItem>
              <ListGroupItem tag={Link} to="/admin/dolar" action>
                Dólar
              </ListGroupItem>
            </>
          )}

          {podeVerLogs && (
            <ListGroupItem tag={Link} to="/admin/logs" action>
              Logs
            </ListGroupItem>
          )}
        </ListGroup>
        <Button
          color="danger"
          onClick={handleLogout}
          block
          style={{ marginTop: 20 }}
        >
          Desconectar da sua conta
        </Button>
      </OffcanvasBody>
    </Offcanvas>
  );
}

export default SideMenuAdmin;